import React from "react";

export function ToastCenter({ toasts, onRemove }) {
  return (
    <div className="toast-wrap">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.type}`}>
          <span>
            {t.type === "success" ? "✓" : t.type === "error" ? "✕" : "ℹ"}
          </span>
          <span style={{ flex: 1 }}>{t.msg}</span>
          <span className="toast-close" onClick={() => onRemove(t.id)}>
            ×
          </span>
        </div>
      ))}
    </div>
  );
}